import { action } from 'easy-peasy';

import { IActionSetCrisisReport } from '../types';

const setCrisisReport: IActionSetCrisisReport = action((state, payload) => {
  if (payload.list) {
    state.crisisReport.list = payload.list;
  }
  if (payload.pagination) {
    state.crisisReport.pagination = payload.pagination;
  }
  if (payload.filters) {
    state.crisisReport.filters = payload.filters;
  }
});

export default setCrisisReport;
